<template>
  <div id="main">
    <Header />
    <Hero />
    <Skill />
    <Feature />
    <Works />
    <Faq />
    <Recruitment />
    <Customer />
    <Footer />

    <!-- 고객문의 -->
    <transition name="fade">
      <Inquiry
        v-if="modal.inquiry"
      />
    </transition>
    <!-- 프로젝트의뢰  -->
    <Request
      v-if="modal.request"
    />
  </div>
</template>
<script>
import Header from '@/views/common/Header'
import Footer from '@/views/common/Footer'
import Hero from '@/views/main/Hero'
import Skill from '@/views/main/Skill'
import Feature from '@/views/main/Feature'
import Works from '@/views/main/Works'
import Faq from '@/views/main/Faq'
import Recruitment from '@/views/main/Recruitment'
import Customer from '@/views/main/Customer'
import Request from '@/views/Request'
import Inquiry from '@/views/Inquiry'

export default {
  name: 'Main',
  components:{
    Header,
    Footer,
    Hero,
    Skill,
    Feature,
    Works,
    Faq,
    Recruitment,
    Customer,
    Request,
    Inquiry,
  },
  data() {
    return {
		} 
  },
  computed: {
    modal() {
      return this.$store.getters.modal
    }
	},
  watch: {},
  created() {},
  mounted() {
	},
  methods: {
  }
};
</script>

<style lang="scss" scoped>
/********************************************************

파일명: main.vue 
작성자:김지혜
작성일자:2020.12.30

[inner] width:1000px;

[header] height:100px; box-shadow, fixed
[main] height:620px
[services] height:485px;
[about] height:918px;
[projects] height:1090px;
[faq]height:1164px;
[recruit]height:634px;
[footer]height:72px(padding:25px 0)

********************************************************/
#main{
  position:relative;
}
</style>
